import { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { useAppSelector } from "../../../context-store";
import CompanyClasses from "../../../landing-pages/Company/company.module.css";
import CompanyAdminDashboardModel from "../../../models/company/addProfiles/response/CompanyAdminDashboardModel";
import companyDashboardService from "../../../services/company/dashboard-service";
import toasterUtils from "../../../utils/toaster-utils";
import modalUtils from "../../../utils/modal-utils";
import loaderUtils from "../../../utils/loader-utils";
import { CircularProgressbar, buildStyles  } from 'react-circular-progressbar';
import { Pie, Bar } from 'react-chartjs-2';
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import { CategoryScale, LinearScale, BarElement } from 'chart.js';

import "./CompanyDashboardComponent.css";

Chart.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const CompanyDashboardComponent = () => {
    let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
    const [adminDasgboardDetails, setAdminDasgboardDetails] = useState<CompanyAdminDashboardModel | null>(null);
    const [interviewsChartValues, setInterviewsChartValues] = useState<number>(0);
    const [refreshDashboard, setRefreshDashboard] = useState<number>(2);
    const history = useHistory();

    useEffect(() => {
        getAdminDashboardDetails();
    }, []);

    const getAdminDashboardDetails = () => {
        if (loggedInUser) {
            setRefreshDashboard(2);
            modalUtils.showLoader();
            companyDashboardService.getCompanyAdminDashboard(loggedInUser?.profileId).then((res) => {
                if (!res.isSuccess || res.errorMessages.length > 0) {
                    toasterUtils.showError(res.errorMessages.toString());
                    return;
                }
                if (res.data.companyAdminDashboardInterviewsModel.interviewsRemaining < 0) {
                    res.data.companyAdminDashboardInterviewsModel.interviewsRemaining = 0;
                }
                setAdminDasgboardDetails(res.data);
                if (res.data.companyAdminDashboardInterviewsModel.interviewsAllowed > 0) {
                    const donutValue = (Number(res.data.companyAdminDashboardInterviewsModel.interviewsUsed) / res.data.companyAdminDashboardInterviewsModel.interviewsAllowed) * 100;
                    setInterviewsChartValues(donutValue > 100 ? 100 : Math.round(donutValue));
                }
                setRefreshDashboard(refreshDashboard * 5);
                modalUtils.closeModal();
            }).catch((error) => {
                setRefreshDashboard(refreshDashboard * 5);
                toasterUtils.showError(error);
                modalUtils.closeModal();
            });
        }
    };

    return (
        <div className="row dashoard-blocks" key={refreshDashboard}>
            <div className="col-lg-6 col-md-6">
                <div className="card card-white">
                    <div className="card-head ">
                            Interviews
                    </div>
                    <div className="card-body dashboard-align-center">
                        <div className="row">
                            <div className="col-md-4 chart-align-center">
                                <div className="chart-element">
                                    
                                        <CircularProgressbar 
                                            className="admin-dashboard-interviews-donut" 
                                            value={interviewsChartValues} 
                                            text={`${interviewsChartValues} %`} 
                                            strokeWidth={7}
                                            styles={buildStyles({
                                                pathColor: "#3e80df ",       // main progress color
                                                trailColor: "#eee",         // background circle color
                                                textColor: "#333",          // center text color
                                                backgroundColor: "#fff",
                                                textSize: "12px",           // font size of center text
                                                pathTransitionDuration: 0.5, // duration of animation when value changes
                                            })}
                                        />
                                    
                                </div>
                            </div>
                            <div className="col-md-8">
                                <div className="stats-modern">
                                    {/* <div className="stat-row blue">
                                        <div className="stat-icon">
                                            <i className="fas fa-clipboard-check"></i>
                                        </div>
                                        <div className="stat-info">
                                            <span className="stat-number">{adminDasgboardDetails?.companyAdminDashboardInterviewsModel.interviewsAllowed}</span>
                                            <span className="stat-label">Interviews Allowed</span>
                                        </div>
                                    </div> */}
                                    <div className="stat-row orange">
                                        <div className="stat-icon">
                                            <i className="fas fa-chart-line"></i>
                                        </div>
                                        <div className="stat-info">
                                            <span className="stat-number">{adminDasgboardDetails?.companyAdminDashboardInterviewsModel.interviewsUsed}</span>
                                            <span className="stat-label">Used</span>
                                        </div>
                                    </div>

                                    <div className="stat-row blue">
                                        <div className="stat-icon">
                                            <i className="fas fa-hourglass-half"></i>
                                        </div>
                                        <div className="stat-info">
                                            <span className="stat-number">{adminDasgboardDetails?.companyAdminDashboardInterviewsModel.interviewsRemaining}</span>
                                            <span className="stat-label">Remaining</span>
                                        </div>
                                    </div>

                                    <div className="stat-row orange">
                                        <div className="stat-icon">
                                            <i className="fas fa-calendar-check"></i>
                                        </div>
                                        <div className="stat-info">
                                            <span className="stat-number">{adminDasgboardDetails?.companyAdminDashboardInterviewsModel.activeInterviews}</span>
                                            <span className="stat-label">Active Schedules</span>
                                        </div>
                                    </div>

                                    <div className="stat-row blue">
                                        <div className="stat-icon">
                                            <i className="fas fa-ban"></i>
                                        </div>
                                        <div className="stat-info">
                                            <span className="stat-number">{adminDasgboardDetails?.companyAdminDashboardInterviewsModel.inActiveInterviews}</span>
                                            <span className="stat-label">Inactive / Junk Schedules</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-lg-6 col-md-6">
                <div className="card card-white">
                    <div className="card-head">
                            Job Postings
                    </div>
                    <div className="card-body dashboard-align-center">
                        <div className="row">
                            <div className="col-md-4 chart-align-center">
                                <div className="admin-dashboard-interviews-left-panel">
                                    {adminDasgboardDetails?.companyAdminDashboardRequirementsModel && (
                                        <Pie className="admin-dashboard-requirements-pie-chart"
                                            data={{
                                                labels: ['Open', 'Closed', 'On Hold'],
                                                datasets: [
                                                    {
                                                        data: [
                                                            adminDasgboardDetails.companyAdminDashboardRequirementsModel.openRequirements,
                                                            adminDasgboardDetails.companyAdminDashboardRequirementsModel.closedRequirements,
                                                            adminDasgboardDetails.companyAdminDashboardRequirementsModel.onHoldRequirements
                                                        ],
                                                        backgroundColor: ['#3e80df', '#d32f0f', '#ffff00'],
                                                        // borderColor: ['#fff', '#fff', '#fff'],
                                                        borderWidth: 2,
                                                    },
                                                ],
                                            }}
                                            options={{
                                                plugins: {
                                                    legend: {
                                                        display: true,
                                                        position: 'bottom',
                                                        labels: {
                                                            color: '#444',
                                                            font: { size: 10 },
                                                            boxWidth: 12,
                                                            boxHeight: 12,
                                                            padding: 5 
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    )}
                                </div>
                            </div>

                            <div className="col-md-8">
                                <div className="stats-modern">
                                    <div className="stat-row blue">
                                        <div className="stat-icon">
                                        <i className="fas fa-briefcase"></i>
                                        </div>
                                        <div className="stat-info">
                                        <span className="stat-number">{adminDasgboardDetails?.companyAdminDashboardRequirementsModel.totalRequirements}</span>
                                        <span className="stat-label">Total Requirements Added</span>
                                        </div>
                                    </div>

                                    <div className="stat-row orange">
                                        <div className="stat-icon">
                                        <i className="fas fa-folder-open"></i>
                                        </div>
                                        <div className="stat-info">
                                        <span className="stat-number">{adminDasgboardDetails?.companyAdminDashboardRequirementsModel.openRequirements}</span>
                                        <span className="stat-label">Open Requirements</span>
                                        </div>
                                    </div>

                                    <div className="stat-row blue">
                                        <div className="stat-icon">
                                        <i className="fas fa-check-circle"></i>
                                        </div>
                                        <div className="stat-info">
                                        <span className="stat-number">{adminDasgboardDetails?.companyAdminDashboardRequirementsModel.closedRequirements}</span>
                                        <span className="stat-label">Closed Requirements</span>
                                        </div>
                                    </div>

                                    <div className="stat-row orange">
                                        <div className="stat-icon">
                                        <i className="fas fa-pause-circle"></i>
                                        </div>
                                        <div className="stat-info">
                                        <span className="stat-number">{adminDasgboardDetails?.companyAdminDashboardRequirementsModel.onHoldRequirements}</span>
                                        <span className="stat-label">On-Hold Requirements</span>
                                        </div>
                                    </div>
                                    </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-lg-6 col-md-6 mx-auto">
                <div className="card card-white">
                    <div className="card-head">
                            Profiles By Skill
                    </div>
                    <div className="card-body dashboard-align-center">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="admin-dashboard-interviews-left-panel">
                                    {adminDasgboardDetails?.companyAdminDashboardProfilesBySkillModel && (
                                        <Bar className="admin-dashboard-requirements-bar-chart"
                                            data={{
                                                labels: adminDasgboardDetails.companyAdminDashboardProfilesBySkillModel.map((item: any) => item.primarySkillName),
                                                datasets: [
                                                    {
                                                        label: 'No Of Profiles',
                                                        data: adminDasgboardDetails.companyAdminDashboardProfilesBySkillModel.map((item: any) => item.noOfCandidatesAdded),
                                                        backgroundColor: '#3e81e0'
                                                        
                                                    },
                                                ],
                                            }}
                                            options={{
                                                responsive: true,
                                                plugins: {
                                                    legend: { display: false },
                                                },
                                                scales: {
                                                    x: {
                                                        title: {
                                                            display: true,
                                                            text: 'Primary Skill',
                                                        },
                                                        ticks: {
                                                            display: false,
                                                        },
                                                    },
                                                    y: {
                                                        title: {
                                                            display: true,
                                                            text: 'No Of Profiles',
                                                        },
                                                        beginAtZero: true,
                                                    },
                                                },
                                            }}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default CompanyDashboardComponent;